// why: the Core > Custom Code Extension can have external scripts, which we will load here!
// by intercepting __registerScript we gain access to the function code as a string :)
import Url from 'url-parse'
export function loadExternalScripts(satellite, assetDomain) {
    window._satellite = window._satellite || satellite
    let urlToActionMapping = {}
    satellite.__registerScript = function (url, f) {
        urlToActionMapping[url].LaunchViewerLoadedCode = `[[[VIEWERBEGIN]]]function (){${f.toString()}}[[[VIEWEREND]]]`
    }
    let rules = satellite._container.rules
    rules.forEach(rule => {
        let actions = rule.actions
        if (!actions) { return }
        rule.actions.forEach(action => {
            if (action.modulePath !== "core/src/lib/actions/customCode.js") { return }
            let settings = action.settings;
            if (settings.isExternal && typeof settings.source === 'string') {
                urlToActionMapping[settings.source] = settings
                let path = Url(settings.source).pathname // ==> support for external asset domain
                let url = 'https://' + assetDomain + path
                addScript(url)
            }
        })
    })
    let keys = Object.keys(urlToActionMapping)
    console.debug(`Loading ${keys.length} external code files (core extension only!)`, keys)
}

function addScript(src, cb) {
    var s = document.createElement('script');
    s.dataset.launchScript = true;
    s.setAttribute('src', src);
    s.onload = function () { typeof cb === 'function' && cb(true) }
    s.onerror = function () { typeof cb === 'function' && cb(false) }
    document.body.appendChild(s);
}

export function deleteExtenalScripts() {
    var nodes = Array.from(
        document.querySelectorAll("script[data-launch-script=true]")
    );
    nodes.forEach((node) => {
        node.parentNode.removeChild(node);
    });
}
